import * as React from 'react';
import { ArticleHeading1, ArticleHeading2, Button, useDeviceType } from '@cian/ui-kit';
import { ConditionalWrapper } from '@cian/conditional-component';

import { Wrapper } from '../Wrapper';
import { EObjectType, OBJECT_TYPES } from '../../constants/objectType';
import { Card } from './components/Card';

import * as styles from './styles.css';

export interface IObjectTypeProps {
  onChange(value: EObjectType): void;
  onClick(): void;
  selectedValue: EObjectType | null;
}

export const ObjectType: React.FC<IObjectTypeProps> = ({ onChange, onClick, selectedValue }) => {
  const isDesktop = useDeviceType() === 'desktop';

  return (
    <div className={styles['container']}>
      <Wrapper>
        <div className={styles['content']}>
          <div className={styles['title']}>
            <ConditionalWrapper if={isDesktop} ThenComponent={ArticleHeading1} ElseComponent={ArticleHeading2}>
              Какую недвижимость хотите проверить?
            </ConditionalWrapper>
          </div>
          <div className={styles['filter']}>
            {OBJECT_TYPES.map(item => {
              return (
                <Card
                  key={item.value}
                  name={item.name}
                  selectedValue={selectedValue}
                  value={item.value}
                  onChange={() => onChange(item.value)}
                />
              );
            })}
          </div>
          <div className={styles['footer']}>
            <Button theme="main_primary" size="M" fullWidth={true} onClick={onClick} disabled={!selectedValue}>
              Продолжить
            </Button>
          </div>
        </div>
      </Wrapper>
    </div>
  );
};

ObjectType.displayName = 'ObjectType';
